import React, { createContext, useContext, useMemo } from "react";

import { Detector } from "types/detectors";

type ImageQueriesTableContextValue = {
  hasDetectors: boolean;
  detector?: Detector;
};

export const ImageQueriesTableContext = createContext<ImageQueriesTableContextValue>({
  hasDetectors: false,
});

type ImageQueriesProviderProps = React.PropsWithChildren<ImageQueriesTableContextValue>;

export function ImageQueriesContextProvider({ children, detector, hasDetectors }: ImageQueriesProviderProps) {
  const value: ImageQueriesTableContextValue = useMemo(
    () => ({
      detector,
			hasDetectors
    }),
    [detector, hasDetectors]
  );

  return <ImageQueriesTableContext.Provider value={value}>{children}</ImageQueriesTableContext.Provider>;
}

export function useImageQueriesTableContext() {
  return useContext(ImageQueriesTableContext);
}
